import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { SessionStorageKey } from 'src/app/shared/enums/session-storage-key.enum';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  constructor() {}

  static IS_COOKIES: SessionStorageKey[] = [
    SessionStorageKey.TOKEN,
    SessionStorageKey.REFRESH_TOKEN,
  ];

  /**
   * @description Armazenar informação no LocalStorage
   *
   * @author Alysson Cordeiro
   *
   * @param key - Chave
   * @param value  - Valor que será armazenado
   */
  storage(key: SessionStorageKey, value: string, expiresIn?: number): void {
    if (SessionStorageService.IS_COOKIES.includes(key)) {
      this.setCookies(key, value, expiresIn);
    } else {
      localStorage.setItem(key, value);
    }
  }

  /**
   * @description Recuperar item do LocalStorage
   *
   * @author Alysson Cordeiro
   *
   * @param key - Chave do item
   */
  getItem(key: SessionStorageKey): string {
    if (SessionStorageService.IS_COOKIES.includes(key)) {
      return this.getCookie(key);
    } else {
      return localStorage.getItem(key);
    }
  }

  /**
   * @description Limpar todo o conteúdo do LocalStorage
   *
   * @author Alysson Cordeiro
   */
  clear(): void {
    SessionStorageService.IS_COOKIES.forEach(this.removeCookie);
    localStorage.clear();
  }

  private setCookies(
    key: SessionStorageKey,
    value: string,
    daysToExpire: number
  ) {
    const date = new Date();
    date.setTime(date.getTime() + daysToExpire * 1000);
    const expires =
      'expires=' +
      formatDate(
        date,
        'EEE, dd MMM yyyy HH:mm:ss UTC',
        'en',
        'America/Sao_Paulo'
      );    
    document.cookie =
      `${key}=${value};${expires};path=/;Secure;SameSite=Strict;` +
      document.cookie;
  }

  private getCookie(key: SessionStorageKey): string | null {
    const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
      const [key, value] = cookie.split('=');
      acc[key] = decodeURIComponent(value);
      return acc;
    }, {});
    return cookies[key] || null;
  }

  private removeCookie(key: SessionStorageKey): void {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}
